export default "__VITE_ASSET__02473dd0__"